export const IMAGE = 'IMAGE';
export const QR = 'QR';
export const POSTER = 'POSTER';
export const EMBED = 'EMBED';
export const INSTAGRAM = 'INSTAGRAM';
export const TVA_IMAGES = 'TVA_IMAGES';
